import PropTypes from 'prop-types'
import React, { useState } from "react"
import { Row, Col } from "reactstrap"
import ReactApexChart from "react-apexcharts"
import { formatCurrency } from '../../Utils/formatters'

const USDT = props => {
  const [menu, setMenu] = useState(false)
  const [currency, setcurrency] = useState("EURO")

  return (
    <React.Fragment>
      {props.reports.map((report, key) => (
        <Col md="12" key={key}>
          <div className='custom-card'>
            <div className='custom-cardbody'>
              <Row>
                <Col sm="6" xs='12'>
                  <div>
                    <p className="h4 card-title" style={{ fontWeight: '700', marginBottom: '12px' }}>Balance</p>
                    <div className="d-flex align-items-center" style={{ gap: '0px', flexWrap: 'nowrap' }}>
                      <h3 style={{ color: "#036B41", fontWeight: '600', fontSize: '37px', marginBottom: 0, whiteSpace: 'nowrap' }}>{currency=="USDT"? parseFloat(report.usdt).toFixed(2) + ' ₮' : formatCurrency(report.euro)}</h3>
                      <select onChange={(e) => setcurrency(e.target.value)} className="select-custom" style={{ border: 'none', background: 'transparent', color: '#036B41', fontWeight: '600', fontSize: '16px', cursor: 'pointer', outline: 'none', marginLeft: '2px' }}>
                        <option value="EURO">EURO</option>
                        <option value="USDT">USDT</option>                      
                      </select>
                    </div>
                  </div>
                </Col>
                <Col sm="6" xs='12'>
                  <div>
                    <div>
                      <ReactApexChart
                        options={report.options}
                        series={currency=="USDT"?report.usdt_series:report.euro_series}
                        type="area"
                        height={70}
                        className="apex-charts"
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      ))}
    </React.Fragment>
  )
}

export default USDT

USDT.propTypes = {
  reports: PropTypes.array
}